import React from "react";
import { FIELD_LABELS } from "../../loanManager/compontents/fieldLabels";

/**
 * Displays data in labeled, read-only inputs using Bootstrap’s grid & form classes.
 *
 * @param {{ title: string, data: Record<string, any> | Record<string, any>[] }} props
 * @returns {JSX.Element | null}
 */
const AppTrackerDataDisplay = ({ title, data, requiredFields = [] }) => {
	const isEmpty =
		data === null ||
		data === undefined ||
		(Array.isArray(data) && data.length === 0) ||
		(typeof data === "object" && Object.keys(data).length === 0);

	if (isEmpty) {
		return null;
	}

	const formatValue = (key, value) => {
		if (typeof value === "boolean") return value ? "Yes" : "No";
		if (key.toLowerCase().includes("date") && value?.length >= 10)
			return new Date(value).toLocaleDateString();
		return value;
	};

	/**
	 * Render each key/value pair as a label + read-only input.
	 * Uses Bootstrap’s form-group and form-control classes.
	 */
	const renderFields = (item) =>
		Object.entries(item).map(([key, value]) => {
			const label = FIELD_LABELS[key] || key;
			const isRequired = requiredFields.includes(key);
			const isMissing =
				isRequired && (value === null || value === undefined || value === "");

			const tooltipText = isMissing
				? "Please add this information in the deal screen before submitting."
				: "";

			return (
				<div className="col" key={key}>
					<div className="form-group">
						<label className="form-label fw-bold">{label}:</label>
						<input
							type="text"
							className={`form-control form-control-sm ${
								isMissing ? "is-invalid" : ""
							}`}
							value={formatValue(key, value) ?? ""}
							disabled
							title={tooltipText}
						/>
					</div>
				</div>
			);
		});

	// grid classes:
	// - xs: 1 col
	// - sm: 2 cols
	// - md+: 6 cols (≈16.7% each)
	const gridClasses = "row row-cols-1 row-cols-sm-2 row-cols-md-6 g-3";

	return (
		<div className="mb-4">
			<h3 className="mb-3">{title}</h3>
			{Array.isArray(data) ? (
				data.map((item, idx) => (
					<div className="card mb-3" key={idx}>
						<div className="card-body">
							<h5 className="card-title">Item #{idx + 1}</h5>
							<div className={gridClasses}>{renderFields(item)}</div>
						</div>
					</div>
				))
			) : (
				<div className="card mb-3">
					<div className="card-body">
						<div className={gridClasses}>{renderFields(data)}</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default AppTrackerDataDisplay;
